import { gql, useQuery } from "@apollo/client";
import {
  FindAllCustomersQueryQuery
} from "../../../schemaTypes";

export const findAllCustomersQuery = gql`
  query FindAllCustomersQuery {
    findAllCustomers {
      id
      avatarUrl
      firstname
      lastname
      email
      username
      phone
      community{
        id
        name
        alias
      }
      createdAt
      updatedAt
      address
      gender
      dob
      nin
    }
  }
`;

export function useFindAllCustomers() {
  const { data, loading } = useQuery<FindAllCustomersQueryQuery>(findAllCustomersQuery);

  return {
    customers: data?.findAllCustomers ?? [],
    loading
  };
}